import * as React from "react";

const IconGaveta = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
    style={{ cursor: "pointer" }}
  >
    <rect width="7" height="7" fill="var(--color-029)" rx="1"></rect>
    <rect
      width="7"
      height="7"
      x="10.5"
      fill="var(--color-029)"
      rx="0.875"
    ></rect>
    <rect width="7" height="7" x="21" fill="var(--color-029)" rx="0.875"></rect>
    <rect
      width="7"
      height="7"
      y="10.5"
      fill="var(--color-029)"
      rx="0.875"
    ></rect>
    <rect
      width="7"
      height="7"
      x="10.5"
      y="10.5"
      fill="var(--color-029)"
      rx="0.875"
    ></rect>
    <rect
      width="7"
      height="7"
      x="21"
      y="10.5"
      fill="var(--color-029)"
      rx="0.875"
    ></rect>
    <rect width="7" height="7" y="21" fill="var(--color-029)" rx="0.875"></rect>
    <rect
      width="7"
      height="7"
      x="10.5"
      y="21"
      fill="var(--color-029)"
      rx="0.875"
    ></rect>
    <rect
      width="7"
      height="7"
      x="21"
      y="21"
      fill="var(--color-029)"
      rx="0.875"
    ></rect>
  </svg>
);

export default IconGaveta;
